"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomBoolEventObserver = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _isSSR = require("../utils/isSSR");

var useCustomBoolEventObserver = function useCustomBoolEventObserver(_ref) {
  var defaultValue = _ref.defaultValue,
      eventKey = _ref.eventKey;

  var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    var listener = function listener(event) {
      var _event$detail;

      setValue(event === null || event === void 0 ? void 0 : (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.value);
    };

    if (!_isSSR.isSSR) {
      window.addEventListener(eventKey, listener);
    }

    return function () {
      if (!_isSSR.isSSR) {
        window.removeEventListener(eventKey, listener);
      }
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (!_isSSR.isSSR) {
      var customEvent = new CustomEvent(eventKey, {
        bubbles: true,
        detail: {
          value: value
        }
      });
      window.dispatchEvent(customEvent);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  return (0, _react.useMemo)(function () {
    return [value, setValue];
  }, [value]);
};

exports.useCustomBoolEventObserver = useCustomBoolEventObserver;